
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IuC5hOC4oeC5iOC4reC4meC4uOC4jeC4suC4leC5g%2BC4q%2BC5ieC4o%2BC4sOC4muC4uCBVcmxzIn0%3D!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IuC5hOC4oeC5iOC4reC4meC4uOC4jeC4suC4leC5g%2BC4q%2BC5ieC4o%2BC4sOC4muC4uCBVcmxzIn0%3D!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybCB0aWRhayBkaWl6aW5rYW4ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybCB0aWRhayBkaWl6aW5rYW4ifQ%3D%3D!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybHMgYXJlIG5vdCBhbGxvd2VkIn0%3D!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IuC5hOC4oeC5iOC4reC4meC4uOC4jeC4suC4leC5g%2BC4q%2BC5ieC4o%2BC4sOC4muC4uCBVcmxzIn0%3D!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IuC5hOC4oeC5iOC4reC4meC4uOC4jeC4suC4leC5g%2BC4q%2BC5ieC4o%2BC4sOC4muC4uCBVcmxzIn0%3D!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybCB0aWRhayBkaWl6aW5rYW4ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlVybCB0aWRhayBkaWl6aW5rYW4ifQ%3D%3D!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlvHmcWZxprFoSDEg8SDxIPFmeG6veG6veG6vSDguIHguLXguYnDtsO2w7bhua8gxIPEg8SDxprGmsO2w7bDtsW14bq94bq94bq9xoxdIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJVcmxzIGFyZSBub3QgYWxsb3dlZCI6IlvHmcWZxprFoSDEg8SDxIPFmeG6veG6veG6vSDguIHguLXguYnDtsO2w7bhua8gxIPEg8SDxprGmsO2w7bDtsW14bq94bq94bq9xoxdIn0%3D!"
        )
      )
      });
  
      export { translations as default };
    